import script from "./ECommerce.vue?vue&type=script&setup=true&lang=ts"
export * from "./ECommerce.vue?vue&type=script&setup=true&lang=ts"

import "./ECommerce.vue?vue&type=style&index=0&id=68407d16&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68407d16"]])

export default __exports__